import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import moment from 'moment';

import { saveAirportServiceData } from '../../actions/airportServices';
import { useHideModal } from '../../actions/modal';
import { useForm } from '../../components/hooks/useForm/useForm';
import { FieldTypes } from '../../components/hooks/useForm/validate';

const fields = {
    dateBegin: { title: 'airportServices.beginPlan', type: FieldTypes.MOMENT },
    dateEnd: { title: 'airportServices.endPlan', type: FieldTypes.MOMENT },
    dateBeginReal: { title: 'airportServices.beginReal', type: FieldTypes.MOMENT, required: false },
    dateEndReal: { title: 'airportServices.endReal', type: FieldTypes.MOMENT, required: false },
    quantity: { title: 'airportServices.quantity', type: FieldTypes.NUMBER, precision: [12, 3], required: false },
};

const getInitialData = (legId, service) => ({
    legId,
    ...service,
    dateBegin: service.dateBegin ? moment.utc(service.dateBegin) : null,
    dateEnd: service.dateEnd ? moment.utc(service.dateEnd) : null,
    dateBeginReal: service.dateBeginReal ? moment.utc(service.dateBeginReal) : null,
    dateEndReal: service.dateEndReal ? moment.utc(service.dateEndReal) : null,
    quantity: service.quantity ? Number(service.quantity).toFixed(3) : '',
});

export const useAirportServiceModal = (legId, service) => {
    const hideModal = useHideModal();
    const dispatch = useDispatch();
    const { t: translate } = useTranslation();

    const handleSuccess = useCallback(
        (data) => {
            dispatch(
                saveAirportServiceData(legId, {
                    ...data,
                })
            );

            hideModal();
        },
        [legId]
    );

    const { inputs, handleInputChange, handleSubmit, status } = useForm({
        onSuccess: handleSuccess,
        initialData: getInitialData(legId, service),
        fields,
    });

    const handleDateChange = useCallback(
        (name, value) =>
            handleInputChange({
                target: {
                    name,
                    value,
                },
            }),
        []
    );

    const actions = useMemo(
        () => [
            { label: translate('cancel'), onClick: hideModal },
            {
                label: translate('ok'),
                color: 'primary',
                type: 'submit',
                disabled: !legId,
            },
        ],
        [hideModal, legId]
    );

    return {
        actions,
        inputs,
        status,
        handleInputChange,
        handleDateChange,
        handleSubmit,
    };
};
